// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Download, FileText } from 'lucide-react';

interface PurchaseData {
  id: string;
  status: string;
  generated_packets: {
    packet_file_url: string;
    packet_name: string;
    events: {
      name: string;
    };
  };
}

export const PacketPurchaseSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [purchase, setPurchase] = useState<PurchaseData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      fetchPurchase();
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  const fetchPurchase = async () => {
    try {
      const { data, error } = await supabase
        .from('packet_purchases')
        .select(`
          id,
          status,
          generated_packets (
            packet_file_url,
            packet_name,
            events (name)
          )
        `)
        .eq('stripe_session_id', sessionId)
        .single();

      if (!error && data) {
        setPurchase(data as any);
      }
    } catch (error) {
      console.error('Error fetching purchase:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background to-secondary/10 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">Processing your purchase...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  const eventName = purchase?.generated_packets?.events?.name || 'the event';
  const packetName = purchase?.generated_packets?.packet_name || 'Event Packet';

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary/10 flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-8 pb-8 text-center">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-2">Purchase Complete!</h1>
          <p className="text-muted-foreground mb-6">
            Your coach packet for <strong>{eventName}</strong> is ready.
          </p>

          <div className="space-y-3">
            <Link to="/college-coach/packets" className="block">
              <Button className="w-full">
                <FileText className="w-4 h-4 mr-2" />
                View My Packets
              </Button>
            </Link>

            {purchase?.generated_packets?.packet_file_url && (
              <Button
                variant="outline"
                className="w-full"
                onClick={() => window.open(purchase.generated_packets.packet_file_url, '_blank')}
              >
                <Download className="w-4 h-4 mr-2" />
                Download Now
              </Button>
            )}
          </div>

          <p className="text-sm text-muted-foreground mt-6">
            A confirmation email has been sent to your registered email address.
          </p>

          {sessionId && (
            <p className="text-xs text-muted-foreground mt-4">
              Transaction ID: {sessionId}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PacketPurchaseSuccess;
